import { Currencies } from "@orbital/games-frontend-library"
import {
  checkStartWithZeros,
  checkMaxMin,
  checkOnlyDot,
} from "../checkers/checkerFunctions"

export const onBlurHelperBetAmount = (
  e: any,
  max: string,
  min: string,
  currency: string,
  setbetAmount: any,
  cashoutAt: string,
  setcashoutAt: any,
  prec: number,
  handleNotification: (a: string) => void,
) => {
  const minCashoutValue = 1.015
  const minC = 1.01
  const multiplier = 10 ** 2
  let value = e.target ? e.target.value : e
  let st = checkStartWithZeros(
    value.slice(Currencies[currency].length, value.length),
  )
  if (checkOnlyDot(st)) {
    // logger.log({ st })
    st = min
  }
  let minMax = +checkMaxMin(
    st,
    max,
    min,
    handleNotification,
    "bet",
    prec,
    currency,
  )
  if (
    Number(cashoutAt.slice(Currencies[currency].length, cashoutAt.length)) /
    Number(minMax) <
    minC
  ) {
    Number(st) < 1 ?
      handleNotification(
        `min CASHOUT AT amount should be 1.01`,
      ) : handleNotification(
        `min CASHOUT AT amount should be ${prec === 0 ? Math.ceil(+st * 1.01) : (+st * 1.01).toFixed(prec)}`,
      )

    const cashout =
      Math.round(+minMax * minCashoutValue * multiplier) / multiplier
    prec === 0
      ? setcashoutAt(Currencies[currency] + Math.ceil(cashout))
      : setcashoutAt(Currencies[currency] + cashout.toFixed(prec))
  }
  if (
    +minMax > +cashoutAt.slice(Currencies[currency].length, cashoutAt.length)
  ) {
    handleNotification(`CASHOUT AT should be more than BET AMOUNT`)
    const cashout =
      Math.round(+minMax * minCashoutValue * multiplier) / multiplier
    prec === 0
      ? setcashoutAt(Currencies[currency] + Math.ceil(cashout))
      : setcashoutAt(Currencies[currency] + cashout.toFixed(prec))
  }
  if (
    Number((+minMax).toFixed(prec)) <=
    Number(cashoutAt.slice(Currencies[currency].length, cashoutAt.length))
  ) {
    const cashout =
      Math.round(
        Number((+minMax).toFixed(prec)) * minCashoutValue * multiplier,
      ) / multiplier

    if (prec === 0 && Math.round(cashout) <= Math.ceil(+st)) {
      setcashoutAt(Currencies[currency] + Math.ceil(cashout))
    }
  }

  setbetAmount(Currencies[currency] + (+minMax).toFixed(prec))
}

export const onBlurHelperNumOfBets = (e: any, setnumOfBets: any) => {
  let value = e.target ? e.target.value : e
  let st: any = checkStartWithZeros(value)
  setnumOfBets(st)
}

export const onBlurHelperCashoutAt = (
  e: any,
  max: string,
  // min: string,
  currency: string,
  setcashoutAt: any,
  betAmount: string,
  prec: number,
  handleNotification: (a: string) => void,
) => {
  const minCashoutValue = 1.015
  const min = 1.01
  const multiplier = 10 ** 2
  let value = e.target ? e.target.value : e

  let val = checkOnlyDot(value.slice(Currencies[currency].length, value.length))
    ? minCashoutValue.toString()
    : value.slice(Currencies[currency].length, value.length)
  let st = checkStartWithZeros(val)

  let minMax = +checkMaxMin(
    st,
    (Number(max) * 5000).toString(),
    minCashoutValue.toString(),
    handleNotification,
    "cashout",
    prec,
    currency,
  )
  let stake = betAmount.slice(Currencies[currency].length, betAmount.length)
  if (Number(minMax) / Number(stake) < min) {
    const cashout = +stake * minCashoutValue
    const finalCashout = prec === 0
      ? Currencies[currency] + Math.ceil(cashout)
      : Currencies[currency] + cashout.toFixed(prec)
    handleNotification(
      `min CASHOUT AT amount should be BET AMOUNT multiplied by 1.01`,
    )
    return setcashoutAt(finalCashout)
  }
  if (+minMax <= +stake) {
    handleNotification(`CASHOUT AT should be more than BET AMOUNT`)
    const cashout =
      Math.round(+stake * minCashoutValue * multiplier) / multiplier
    prec === 0
      ? setcashoutAt(Currencies[currency] + Math.ceil(cashout))
      : setcashoutAt(Currencies[currency] + cashout.toFixed(prec))
  } else {
    // const cashout = Math.round(+minMax * multiplier) / multiplier
    return prec === 0
      ? setcashoutAt(Currencies[currency] + Math.ceil(minMax))
      : setcashoutAt(Currencies[currency] + minMax.toFixed(prec))
  }
}
